"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
/** @jsxFrag React.Fragment */
const b_1 = __importDefault(require("b_"));
const react_1 = require("react");
const react_2 = require("@emotion/react");
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const modal_1 = require("src/context/modal");
const question_1 = __importDefault(require("../question"));
const option_1 = __importDefault(require("../question-choice/option"));
const question_table_styles_1 = __importDefault(require("./question-table.styles"));
const b = b_1.default.with('question-table');
const i18n = (0, pythia_libs_1.i18n)(['commonComponents']);
// @ts-expect-error TS(2345): Argument of type 'readonly ["blockquote", "fence",... Remove this comment to see the full error message
const markdownRenderer = (0, pythia_libs_1.factoryRenderer)(pythia_libs_1.MARKDOWN_OPTIONS);
function QuestionTable(props) {
    const { type, id, columns, rows, multipleChoice, maxAnswerCountPerRow } = props, rest = __rest(props, ["type", "id", "columns", "rows", "multipleChoice", "maxAnswerCountPerRow"]);
    const stylesApplied = (0, question_table_styles_1.default)({ columns, rows, id });
    const caption = multipleChoice && maxAnswerCountPerRow
        ? i18n(['table', 'chooseNoMore'], maxAnswerCountPerRow).replace('%s', maxAnswerCountPerRow.toString())
        : null;
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { type: type, id: id, caption: caption }, { children: [(0, jsx_runtime_1.jsx)(react_2.Global, { styles: stylesApplied }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('') }, { children: [(0, jsx_runtime_1.jsx)(TableHeader, { columns: columns }), (0, jsx_runtime_1.jsx)(TableRows, Object.assign({}, props))] }))] })));
}
exports.default = QuestionTable;
function TableHeader(props) {
    const { isDemo } = (0, modal_1.useModalContext)();
    const { columns } = props;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('columns-header', { isDemo }) }, { children: [(0, jsx_runtime_1.jsx)("div", { className: b('filler') }), columns.map(({ label, attachments }, index) => {
                const questionLabel = markdownRenderer(label);
                return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('column-title', {
                        withoutImage: !(attachments && attachments.length > 0),
                        withoutLabel: !label
                    }) }, { children: [(0, jsx_runtime_1.jsx)("div", { className: b('column-title-label'), 
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: { __html: questionLabel } }), (0, jsx_runtime_1.jsx)(ImageZoomer, { attachments: attachments })] }), index));
            })] })));
}
function TableRows(props) {
    const { id, columns, rows, boundQuestions, boundQuestionsRevision, handleClickOption, multipleChoice, maxAnswerCountPerRow, value } = props;
    const allHaveNoLabels = columns.every(({ label }) => !label);
    const handleTileClick = e => {
        var _a;
        (_a = e.target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.click();
    };
    const isOptionDisabled = (questionIdx, optionIdx, options) => multipleChoice &&
        maxAnswerCountPerRow &&
        (value === null || value === void 0 ? void 0 : value[questionIdx].ids.length) >= maxAnswerCountPerRow &&
        !options[optionIdx].checked;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('rows') }, { children: rows.map(({ label: rowLabel, attachments: rowAttachments }, index) => {
            const questionIndex = boundQuestions[index];
            const keyId = `q${questionIndex}o${index}`;
            const { options } = boundQuestionsRevision[questionIndex];
            const rowLabelHTML = markdownRenderer(rowLabel);
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b(`row-${id}`, {
                    noSelection: options.every(option => !option.checked),
                    multipleChoice
                }) }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('row-header') }, { children: [rowLabel && ((0, jsx_runtime_1.jsx)("div", { className: b('row-header-text'), dangerouslySetInnerHTML: { __html: rowLabelHTML } })), (0, jsx_runtime_1.jsx)(ImageZoomer, { attachments: rowAttachments })] })), columns.map(({ label: columnLabel, attachments: columnAttachments }, i) => {
                        let justifyContent;
                        if (allHaveNoLabels) {
                            justifyContent = 'start';
                        }
                        else {
                            justifyContent = columnLabel ? 'space-between' : 'end';
                        }
                        const columnLabelHTML = markdownRenderer(columnLabel);
                        return (
                        // eslint-disable-next-line react/no-array-index-key
                        (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('row-container') }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('column-title-mobile'), style: { justifyContent } }, { children: [(0, jsx_runtime_1.jsx)("div", { className: b('label-text'), dangerouslySetInnerHTML: { __html: columnLabelHTML } }), (0, jsx_runtime_1.jsx)(ImageZoomer, { attachments: columnAttachments })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('row-option'), onClick: handleTileClick }, { children: (0, jsx_runtime_1.jsx)(option_1.default, { id: `q${questionIndex}op${options[i].id}`, disabled: isOptionDisabled(questionIndex, i, options), value: options[i].id, multipleChoice: multipleChoice, checked: options[i].checked, handleClickOption: e => {
                                            handleClickOption(id, questionIndex, e.target.value);
                                        } }) }), `${keyId}col${options[i].id}`)] }), `${keyId}col${i}`));
                    })] }), `${keyId}row`));
        }) })));
}
function ImageZoomer(props) {
    const { attachments } = props;
    const [isfullyRendered, setIsFullyRendered] = (0, react_1.useState)(false);
    const { showImageModal } = (0, modal_1.useModalContext)();
    const shouldRenderOriginalImageSize = (e) => {
        const image = e.target;
        if (image.naturalWidth < image.width && image.naturalHeight < image.height) {
            image.style.objectFit = 'none';
            setIsFullyRendered(true);
        }
    };
    const handleOnClick = url => {
        if (!isfullyRendered) {
            showImageModal(url);
            return;
        }
        return false;
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: attachments === null || attachments === void 0 ? void 0 : attachments.map(({ url }) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('image-container', { zoomable: !isfullyRendered }), onClick: () => handleOnClick(url) }, { children: (0, jsx_runtime_1.jsx)("img", { className: b('column-image'), src: url, onLoad: shouldRenderOriginalImageSize }) }), url))) }));
}
